Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
{ maybeDisplayCardLimitsError } = require 'views/card/card-limits-error'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/list_copy'
track = require 'debug/track'

module.exports = class ListCopyView extends View
  viewTitleKey: 'copy list'

  tagName: 'form'

  events:
    'click .js-submit': 'submit'
    'submit': 'submit'
    'keydown textarea[name="name"]': 'keydownEvent'

  initialize: ->
    @listenTo @model.getBoard(), 'change:limits', @render

  render: ->
    board = @model.getBoard()
    @$el.html template({
      canCopyTotal: !board.isOverLimit('lists', 'totalPerBoard')
      canCopyOpen: !board.isOverLimit('lists', 'openPerBoard')
      name: @model.get('name')
    })

    @

  keydownEvent: (e) ->
    if Keyboard.getKey(e) == Keys.Enter
      Util.stop(e)
      @submit(e)
      return

  submit: (e) ->
    Util.stop(e)
    nameInput = @$('textarea[name="name"]')

    # return if the user hasn't entered a title
    if nameInput.val().trim() == ''
      nameInput.focus().select()
      return

    board = @model.getBoard()
    isOverLimit = board.isOverLimit('lists', 'totalPerBoard') ||
    board.isOverLimit('lists', 'openPerBoard')
    @$('.js-limit-exceeded').toggleClass('hide', !isOverLimit)
    if isOverLimit
      return

    if @model.cardList.length > 0 && maybeDisplayCardLimitsError(e, board, null)
      return

    listPos = board.listList.calcPos(@model.getIndexInList() + 1, @model, true)
    newListParams =
      idListSource: @model.id
      idBoard: @model.get('idBoard')
      pos: listPos
      name: nameInput.val().trim()
      closed: false

    newList = board.listList.create newListParams,
      error: =>
        board.listList.remove(newList)
    PopOver.hide()
    track("List", "Copy List")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-copy-view.coffee